import { css } from '@emotion/react';
import { blue05 } from 'athena/styles/colors';
import { black } from 'styles/global_defaults/colors';
import { Button } from 'react-bootstrap';
import t from 'react-translate';
import prodPathReplace from 'shared/prod-path-rewrite';
import {
  halfSpacing,
  largeSpacing,
  standardSpacing,
} from 'styles/global_defaults/scaffolding';
import { config } from '@config/pendo.config.json';

type PulseCheckCTAProps = {
  sessionId: number;
  openSessionPulseCheck: () => void;
};

const styles = css`
  gap: ${halfSpacing}px;
  padding: ${standardSpacing}px ${largeSpacing}px;
  background-color: ${blue05};
  border-radius: ${halfSpacing}px;
  box-shadow: 1px 2px 2px 0px #0000001A;

  .pulse-check-cta-title,
  .pulse-check-cta-description {
    color: ${black} !important;
  }

  .pulse-check-cta-image {
    bottom: 0;
    right: 0;
    width: 256px;
    height: 90px;
  }

  button {
    width: 137px;
  }
`;

const PulseCheckCTA = ({
  sessionId,
  openSessionPulseCheck,
}: PulseCheckCTAProps) => {
  const translationBase = t.MENTORING_PROGRAMS.PARTICIPANT_HOME.SESSION_PULSE_CHECK.CTA;
  const src = prodPathReplace('images/pulse-check.svg');
  const shareFeedbackDataQATag = config.pendo.athena.mentorshipProgram.participantHome.sessionPulseCheck
    .shareFeedbackButton;

  return (
    <div css={styles} className='d-flex flex-column position-relative'>
      <div className='heading-5 pulse-check-cta-title'>
        {translationBase.TITLE()}
      </div>
      <div className='text-body pulse-check-cta-description'>
        {translationBase.DESCRIPTION()}
      </div>
      <Button
        variant='primary'
        onClick={openSessionPulseCheck}
        data-qa={shareFeedbackDataQATag}
        data-qa-id={`${shareFeedbackDataQATag}_${sessionId}`}
      >
        {translationBase.BUTTON()}
      </Button>
      <img
        src={src}
        alt={translationBase.TITLE()}
        className='position-absolute pulse-check-cta-image'
      />
    </div>
  );
};

export default PulseCheckCTA;
